export default __webpack_public_path__ + "static/media/filtericon.0828e4be.svg";